<script>
import {ContentLoader} from 'vue-content-loader';
import loaders from '@advisor/components/common/loaders';
import {LOADER_TYPE, LOADER_DISPLAY_TYPE} from '@advisor/util/constants';

export default {
  name: 'AdvLoader',

  components: {
    ...loaders,
    ContentLoader,
  },
  model: {
    prop: 'isLoading',
    event: 'change',
  },

  props: {
    isLoading: {
      required: true,
      type: Boolean,
    },

    type: {
      required: false,
      default: LOADER_TYPE.STANDARD,
      type: String,
      validator: (type) => Object.values(LOADER_TYPE).includes(type),
    },

    display: {
      required: false,
      default: LOADER_DISPLAY_TYPE.SQUARE,
      type: String,
    },

    options: {
      required: false,
      default: () => ({}),
      type: Object,
    },
  },
  computed: {
    componentProps() {
      return {
        display: this.display,
        options: this.options,
        ...this.$attrs,
      };
    },
  },
};
</script>

<template>
  <div v-if="isLoading">
    <v-flex>
      <!-- Dynamic loader component -->
      <component :is="type" v-bind="componentProps" />
    </v-flex>
  </div>

  <div v-else>
    <!-- Slot: Component/Section to be displayed when data is available -->
    <slot />
  </div>
</template>
